export const Scripts = {
    WISTIA: 'https://fast.wistia.com/assets/external/E-v1.js',
    DATEV_MARKETING: 'https://www.datev-mymarketing.de/onlineMedia/code.js?ids=84343',
    HUBSPOT_MEETING_BOOKER: 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js',
    TYPEFORM_SCRIPT_SRC: 'https://embed.typeform.com/next/embed.js',
} as const
